export const SECTION_NAME = 'MCP Limits Changes';

export const MCP_LIMIT_LOG_PAGE_SIZES = [25, 50, 100];
